import { getVoluntariosBySolicitud } from '../../api/solicitudes/getVoluntariosBySolicitud';
import { Voluntario } from '../../types/voluntarios/Voluntario';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const initialState = {
  errors: null,
  loading: false,
  data: [] as Voluntario[],
};

const listVoluntariosBySolicitudModule = createApiModule({
  name: 'listVoluntariosBySolicitud',
  apiMethod: getVoluntariosBySolicitud,
  initialState,
  parse: (voluntarios) =>
    voluntarios.filter((voluntario) => (voluntario.user ? voluntario : null)),
  onSuccess: () => {},
  onError: () => ({
    message: t(
      'StoreVoluntariosListVoluntariosModuleErrorListandoLosVoluntarios',
    ),
  }),
  onValidationError: () => {},
});

export const {
  start: listVoluntariosBySolicitud,
  success: listVoluntariosBySolicitudOk,
  error: listVoluntariosBySolicitudKo,
  refresh: listVoluntariosBySolicitudRefresh,
  reset: listVoluntariosBySolicitudReset,
} = listVoluntariosBySolicitudModule.slice.actions;

export const { sagas } = listVoluntariosBySolicitudModule;

export default listVoluntariosBySolicitudModule;
